import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { Text } from '../../../styles/Components'

const MissionWrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .mission-inner {
    padding-left: 104px;
    margin: 88px 88px 50px 88px;
    border-left: 1px solid #000;

    ${mq('max', '768px')} {
      margin: 38px 16px;
      padding-left: 30px;
    }
  }
`

const MissionSection = () => (
  <MissionWrapper>
    <div className='mission-inner'>
      <Text variant='large'>
        We&apos;re on a mission to eliminate bad hair days, chipped nails, and smokey-eye fails by bringing certified and talented hair stylists, makeup artists, and nail pros right to your door.
      </Text>
    </div>
  </MissionWrapper>
)

export default MissionSection
